import { Box, Button, styled } from '@mui/material';

export const DetailsContainerBox = styled(Box)(({ theme }) => ({
    margin: theme.spacing(5),
    [theme.breakpoints.down('sm')]: {
        margin: theme.spacing(0),
    },
}));

export const DetailsInnerContainerBox = styled(Box)(({ theme }) => ({
    padding: theme.spacing(4),
    [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(0),
    },
}));

export const DetailsTableContainerBox = styled(Box)(({ theme }) => ({
    minHeight: '100px',
    overflow: 'auto',
    [theme.breakpoints.down('sm')]: {
        height: '100%',
    },
}));

export const GoogleMapsFormContainerBox = styled(Box)(({ theme }) => ({
    padding: theme.spacing(5),
    width: '50vw',
    maxWidth: '100%',
    [theme.breakpoints.down('sm')]: {
        width: '100%',
        padding: theme.spacing(1),
    },
}));

export const GoodsElementFormContainerBox = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
    },
}));

export const GoodsToSiteSaveButton = styled(Button)(({ theme }) => ({
    width: '150px',
    [theme.breakpoints.down('sm')]: {
        width: '100%',
    },
}));
